import Login from "../components/login/login";

function Admin(){
    return(
        <>
        <Login/>
        </>
    )
}
export default Admin